import { RouteConfig } from 'vue-router'

const Login = () => import('../../views/account/Login.vue')

export const loginRoute: RouteConfig = {
  path: '/account/login',
  name: 'account_login',
  component: Login,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '天天跳绳',
  },
}

export default [loginRoute]
